import React from 'react';
export function AboutEediSection() {
  return <section className="py-16 bg-gray-50" id="about-eedi" data-id="element-73">
      {/* Visual divider at the top of the section */}
      <div className="relative mb-16" data-id="element-74">
        <div className="absolute inset-0 flex items-center" data-id="element-75">
          <div className="w-full border-t border-gray-300" data-id="element-76"></div>
        </div>
        <div className="relative flex justify-center" data-id="element-77">
          <div className="px-4 bg-gray-50" data-id="element-78">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center shadow-md" data-id="element-79">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-80">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" data-id="element-81"></path>
                <path d="m7 10 5 5 5-5" data-id="element-82"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4" data-id="element-83">
        <div className="max-w-4xl mx-auto" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-85">
            About Eedi: A Research-Led Approach
          </h2>
          <p className="text-lg text-gray-700 mb-10" data-id="element-86">
            At Eedi, we are committed to understanding and solving the biggest
            challenges in education. For over a decade, we have collaborated
            with experts at leading institutions to develop innovative models
            that accurately predict and improve student learning in mathematics.
          </p>
          {/* Mission statement with enhanced visibility */}
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-8 rounded-xl border-l-4 border-purple-600 mb-10" data-id="element-87">
            <p className="text-2xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-blue-700" data-id="element-88">
              Our mission is to sustainably improve learning outcomes for 1
              billion students by 2030.
            </p>
          </div>
          <h3 className="text-xl font-semibold mb-6 mt-10" data-id="element-89">
            Our work is built on three core principles:
          </h3>
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-90">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-91">
              <h4 className="font-bold text-lg mb-2 text-purple-700" data-id="element-92">
                Learning Engineering
              </h4>
              <p className="text-gray-700" data-id="element-93">
                We partner with experts at leading institutions like Cambridge
                and Stanford to develop and validate our advanced models.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-94">
              <h4 className="font-bold text-lg mb-2 text-blue-700" data-id="element-95">
                Intelligent Technology
              </h4>
              <p className="text-gray-700" data-id="element-96">
                Our platform uses high-quality expert-authored diagnostic
                questions and personalised interventions to identify and resolve
                student misconceptions.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-97">
              <h4 className="font-bold text-lg mb-2 text-indigo-700" data-id="element-98">
                Proven Efficacy
              </h4>
              <p className="text-gray-700" data-id="element-99">
                Our impact is verified by rigorous research. An independent
                Randomised Controlled Trial (RCT) found students using Eedi
                achieved an additional 2-3 months of maths progress within a
                year.
              </p>
            </div>
          </div>
          {/* Research partners section */}
          <div className="mt-12 bg-white p-8 rounded-lg shadow-sm" data-id="element-100">
            <h3 className="text-xl font-semibold mb-4 text-center" data-id="element-101">
              Our Research Partners
            </h3>
            <p className="text-center text-gray-600 mb-8" data-id="element-102">
              We collaborate with world-leading institutions and research teams
            </p>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center" data-id="element-103">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bFT3W5V4sSGwhJePryGneh/university-of-cambridge.png" alt="University of Cambridge" className="max-h-12 w-auto mx-auto" data-id="element-104" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qugHQxBGK3y3qnxPRiDXLZ/University_of_Oxford.svg" alt="University of Oxford" className="max-h-12 w-auto mx-auto" data-id="element-105" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/97rTr49qs5BVcEUxbK2XUJ/stanford_university.png" alt="Stanford University" className="max-h-12 w-auto mx-auto" data-id="element-106" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rC37MLLo2uuM57piq9P2Bs/Google_DeepMind_logo.svg.png" alt="Google DeepMind" className="max-h-12 w-auto mx-auto" data-id="element-107" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dowQzvGYxnoZaA2VRTUe4n/Segoe_msr_logo.png" alt="Microsoft Research" className="max-h-12 w-auto mx-auto" data-id="element-108" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}